module.exports = {
	"version": "2022-06-30",
	"license": "CC-BY-SA-3",
	"holidays": {
		"US": {
			"names": {
				"en": "United States of America"
			},
			"dayoff": "sunday",
			"zones": [
				"America/New_York",
				"America/Detroit",
				"America/Kentucky/Louisville",
				"America/Kentucky/Monticello",
				"America/Indiana/Indianapolis",
				"America/Indiana/Vincennes",
				"America/Indiana/Winamac",
				"America/Indiana/Marengo",
				"America/Indiana/Petersburg",
				"America/Indiana/Vevay",
				"America/Chicago",
				"America/Indiana/Tell_City",
				"America/Indiana/Knox",
				"America/Menominee",
				"America/North_Dakota/Center",
				"America/North_Dakota/New_Salem",
				"America/North_Dakota/Beulah",
				"America/Denver",
				"America/Boise",
				"America/Phoenix",
				"America/Los_Angeles",
				"America/Metlakatla",
				"America/Anchorage",
				"America/Juneau",
				"America/Sitka",
				"America/Yakutat",
				"America/Nome",
				"America/Adak",
				"Pacific/Honolulu"
			],
			"langs": [
				"en-us",
				"en"
			],
			"days": {
				"01-01 and if sunday then next monday if saturday then previous friday": {
					"substitute": true,
					"_name": "01-01"
				},
				"3rd monday in January": {
					"name": {
						"en": "Martin Luther King Day"
					}
				},
				"3rd monday in February": {
					"name": {
						"en": "Washington’s Birthday"
					}
				},
				"02-14": {
					"_name": "02-14",
					"type": "observance"
				},
				"04-15 if friday then next monday if saturday,sunday then next tuesday": {
					"name": {
						"en": "Tax Day"
					},
					"type": "observance"
				},
				"wednesday before 04-28": {
					"name": {
						"en": "Administrative Professionals Day"
					},
					"type": "observance"
				},
				"2nd sunday in May": {
					"_name": "Mothers Day",
					"type": "observance"
				},
				"monday before 06-01": {
					"name": {
						"en": "Memorial Day"
					}
				},
				"3rd sunday in June": {
					"_name": "Fathers Day",
					"type": "observance"
				},
				"07-04 and if sunday then next monday if saturday then previous friday": {
					"substitute": true,
					"_name": "Independence Day"
				},
				"monday in September": {
					"_name": "05-01"
				},
				"2nd monday in October": {
					"name": {
						"en": "Columbus Day"
					}
				},
				"10-31 18:00": {
					"name": {
						"en": "Halloween"
					},
					"type": "observance"
				},
				"11-11": {
					"name": {
						"en": "Veterans Day"
					}
				},
				"tuesday after 1st monday in November every 4 years since 1848": {
					"name": {
						"en": "Election Day"
					},
					"type": "observance"
				},
				"4th thursday in November": {
					"name": {
						"en": "Thanksgiving Day"
					}
				},
				"friday after 4th thursday in November": {
					"name": {
						"en": "Day after Thanksgiving Day"
					},
					"type": "observance"
				},
				"12-24": {
					"_name": "12-24",
					"type": "optional"
				},
				"12-25 and if sunday then next monday if saturday then previous friday": {
					"substitute": true,
					"_name": "12-25"
				},
				"12-31 18:00": {
					"_name": "12-31",
					"type": "observance"
				}
			},
			"states": {
				"AL": {
					"name": "Alabama",
					"zones": [
						"America/Chicago"
					],
					"days": {
						"3rd monday in January": {
							"name": {
								"en": "Robert E. Lee/ Martin Luther King Birthday"
							}
						},
						"3rd monday in February": {
							"name": {
								"en": "George Washington/ Thomas Jefferson Birthday"
							}
						},
						"4th monday in April": {
							"name": {
								"en": "Confederate Memorial Day"
							}
						},
						"1st monday in June": {
							"name": {
								"en": "Jefferson Davis' birthday"
							}
						}
					}
				},
				"AK": {
					"name": "Alaska",
					"zones": [
						"America/Anchorage",
						"America/Metlakatla",
						"America/Juneau",
						"America/Sitka",
						"America/Yakutat",
						"America/Nome"
					],
					"days": {
						"2nd monday in October": false,
						"monday before April": {
							"name": {
								"en": "Seward's Day"
							}
						},
						"10-18": {
							"name": {
								"en": "Alaska Day"
							}
						}
					}
				},
				"AZ": {
					"name": "Arizona",
					"zones": [
						"America/Phoenix",
						"America/Denver"
					],
					"days": {
						"3rd monday in January": {
							"name": {
								"en": "Dr. Martin Luther King Jr./ Civil Rights Day"
							}
						}
					}
				},
				"AR": {
					"name": "Arkansas",
					"zones": [
						"America/Chicago"
					],
					"days": {
						"3rd monday in January": {
							"name": {
								"en": "Dr. Martin Luther King Jr./ Robert E. Lee's Birthdays"
							}
						},
						"3rd monday in February": {
							"name": {
								"en": "George Washington's Birthday/ Daisy Gatson Bates Day"
							}
						},
						"12-24": {
							"_name": "12-24"
						}
					}
				},
				"CA": {
					"name": "California",
					"zones": [
						"America/Los_Angeles"
					],
					"days": {
						"2nd monday in October": false,
						"02-15": {
							"name": {
								"en": "Susan B. Anthony Day"
							}
						},
						"03-31": {
							"name": {
								"en": "César Chávez Day"
							}
						},
						"05-19": {
							"name": {
								"en": "Malcolm X Day"
							}
						},
						"05-23": {
							"name": {
								"en": "Harvey Milk Day"
							}
						}
					},
					"regions": {
						"LA": {
							"name": "Los Angeles",
							"days": {
								"08-24": {
									"name": {
										"en": "Kobe Bryant Day"
									},
									"type": "observance",
									"active": [
										{
											"from": 2016
										}
									]
								}
							}
						}
					}
				},
				"CO": {
					"name": "Colorado",
					"zones": [
						"America/Denver"
					],
					"days": {
						"2nd monday in October": {
							"type": "observance"
						}
					}
				},
				"CT": {
					"name": "Connecticut",
					"zones": [
						"America/New_York"
					],
					"days": {
						"02-12": {
							"name": {
								"en": "Lincoln's Birthday"
							}
						},
						"easter -2": {
							"_name": "easter -2"
						}
					}
				},
				"DE": {
					"name": "Delaware",
					"days": {
						"2nd monday in October": false,
						"3rd monday in February": false,
						"easter -2": {
							"_name": "easter -2"
						},
						"friday after 4th thursday in November": {
							"name": {
								"en": "Day After Thanksgiving"
							}
						},
						"tuesday after 1st monday in November in even years": {
							"name": {
								"en": "Election Day"
							}
						}
					}
				},
				"DC": {
					"name": "District of Columbia",
					"days": {
						"04-16": {
							"name": {
								"en": "Emancipation Day"
							}
						}
					}
				},
				"FL": {
					"name": "Florida",
					"days": {
						"2nd monday in October": false,
						"3rd monday in February": false,
						"02-15": {
							"name": {
								"en": "Susan B. Anthony Day"
							}
						},
						"friday after 4th thursday in November": {
							"name": {
								"en": "Day After Thanksgiving"
							}
						}
					}
				},
				"GA": {
					"name": "Georgia",
					"days": {
						"3rd monday in February": false,
						"01-19": {
							"name": {
								"en": "Robert E. Lee's Birthday"
							}
						},
						"monday before 05-01": {
							"name": {
								"en": "Confederate Memorial Day"
							}
						},
						"12-24": {
							"name": {
								"en": "Washington's Birthday"
							}
						},
						"substitutes 12-24 if wednesday then next friday": {
							"substitute": true,
							"name": {
								"en": "Washington's Birthday"
							}
						}
					}
				},
				"HI": {
					"name": "Hawaii",
					"zones": [
						"Pacific/Honolulu"
					],
					"days": {
						"3rd monday in February": false,
						"03-26": {
							"name": {
								"en": "Prince Jonah Kuhio Kalanianaole Day"
							}
						},
						"06-11": {
							"name": {
								"en": "Kamehameha Day"
							}
						},
						"3rd friday in August": {
							"name": {
								"en": "Statehood Day"
							}
						},
						"tuesday after 1st monday in November in even years": {
							"name": {
								"en": "Election Day"
							}
						}
					}
				},
				"ID": {
					"name": "Idaho",
					"zones": [
						"America/Boise",
						"America/Los_Angeles"
					],
					"days": {
						"3rd monday in January": {
							"name": {
								"en": "Martin Luther King, Jr./ Idaho Human Rights Day"
							}
						}
					}
				},
				"IL": {
					"name": "Illinois",
					"zones": [
						"America/Chicago"
					],
					"days": {
						"02-12": {
							"name": {
								"en": "Lincoln's Birthday"
							}
						},
						"1st monday in March": {
							"name": {
								"en": "Casimir Pulaski Day"
							}
						},
						"05-19": {
							"name": {
								"en": "Malcolm X Day"
							}
						},
						"tuesday after 1st monday in November in even years": {
							"name": {
								"en": "Election Day"
							}
						}
					}
				},
				"IN": {
					"name": "Indiana",
					"zones": [
						"America/Indiana/Indianapolis",
						"America/Indiana/Vincennes",
						"America/Indiana/Winamac",
						"America/Indiana/Marengo",
						"America/Indiana/Petersburg",
						"America/Indiana/Vevay",
						"America/Indiana/Tell_City",
						"America/Indiana/Knox"
					],
					"days": {
						"easter -2": {
							"_name": "easter -2"
						},
						"tuesday after 1st monday in May": {
							"name": {
								"en": "Primary Election Day"
							}
						},
						"tuesday after 1st monday in November": {
							"name": {
								"en": "Election Day"
							}
						},
						"friday after 4th thursday in November": {
							"name": {
								"en": "Lincoln's Birthday"
							}
						}
					}
				},
				"IA": {
					"name": "Iowa",
					"zones": [
						"America/Chicago"
					],
					"days": {
						"02-12": {
							"name": {
								"en": "Lincoln's Birthday"
							}
						}
					}
				},
				"KS": {
					"name": "Kansas",
					"zones": [
						"America/Chicago",
						"America/Denver"
					],
					"days": {
						"3rd monday in February": false
					}
				},
				"KY": {
					"name": "Kentucky",
					"zones": [
						"America/Kentucky/Louisville",
						"America/Kentucky/Monticello"
					],
					"days": {
						"3rd monday in February": false,
						"easter -2 14:00": {
							"_name": "easter -2"
						},
						"12-24": {
							"_name": "12-24"
						},
						"12-31": {
							"_name": "12-31"
						}
					}
				},
				"LA": {
					"name": "Louisiana",
					"zones": [
						"America/Chicago"
					],
					"days": {
						"easter -2": {
							"_name": "easter -2"
						},
						"tuesday after 1st monday in November in even years": {
							"name": {
								"en": "Election Day"
							}
						}
					},
					"regions": {
						"NO": {
							"name": "New Orleans",
							"days": {
								"easter -47": {
									"_name": "easter -47",
									"name": {
										"en": "Mardi Gras"
									}
								}
							}
						}
					}
				},
				"ME": {
					"name": "Maine",
					"zones": [
						"America/New_York"
					],
					"days": {
						"3rd monday in April": {
							"name": {
								"en": "Patriots' Day"
							}
						}
					}
				},
				"MD": {
					"name": "Maryland",
					"zones": [
						"America/New_York"
					],
					"days": {
						"friday before 1st monday before 06-01": {
							"name": {
								"en": "Service Reduction Day"
							}
						},
						"friday after 4th thursday in November": {
							"name": {
								"en": "Native American Heritage Day"
							}
						}
					}
				},
				"MA": {
					"name": "Massachusetts",
					"zones": [
						"America/Chicago"
					],
					"days": {
						"03-17": {
							"name": {
								"en": "Evacuation Day"
							}
						},
						"3rd monday in April": {
							"name": {
								"en": "Patriots' Day"
							}
						},
						"06-17": {
							"name": {
								"en": "Bunker Hill Day"
							}
						}
					}
				},
				"MI": {
					"name": "Michigan",
					"zones": [
						"America/Detroit",
						"America/Menominee"
					],
					"days": {
						"12-24": {
							"_name": "12-24"
						},
						"12-31": {
							"_name": "12-31"
						}
					}
				},
				"MN": {
					"name": "Minnesota",
					"zones": [
						"America/Chicago"
					]
				},
				"MS": {
					"name": "Mississippi",
					"zones": [
						"America/Chicago"
					],
					"days": {
						"3rd monday in January": {
							"name": {
								"en": "Martin Luther King's and Robert E. Lee's Birthdays"
							}
						},
						"monday before 05-01": {
							"name": {
								"en": "Confederate Memorial Day"
							}
						}
					}
				},
				"MO": {
					"name": "Missouri",
					"zones": [
						"America/Chicago"
					],
					"days": {
						"05-08": {
							"name": {
								"en": "Truman Day"
							}
						}
					}
				},
				"MT": {
					"name": "Montana",
					"zones": [
						"America/Denver"
					],
					"days": {
						"tuesday after 1st monday in November": {
							"name": {
								"en": "Election Day"
							}
						},
						"12-24": {
							"_name": "12-24"
						},
						"12-31": {
							"_name": "12-31"
						}
					}
				},
				"NE": {
					"name": "Nebraska",
					"zones": [
						"America/Chicago",
						"America/Denver"
					],
					"days": {
						"friday before 05-01": {
							"name": {
								"en": "Arbor Day"
							}
						}
					}
				},
				"NV": {
					"name": "Nevada",
					"zones": [
						"America/Los_Angeles"
					],
					"days": {
						"2nd monday in October": false,
						"friday before 11-01": {
							"name": {
								"en": "Nevada Day"
							}
						},
						"4th friday in November": {
							"name": {
								"en": "Family Day"
							}
						}
					}
				},
				"NH": {
					"name": "New Hampshire",
					"zones": [
						"America/New_York"
					],
					"days": {
						"2nd monday in October": {
							"type": "observance"
						},
						"3rd monday in January": {
							"name": {
								"en": "Martin Luther King, Jr./ Civil Rights Day"
							}
						},
						"tuesday after 1st monday in November in even years": {
							"name": {
								"en": "Election Day"
							}
						},
						"friday after 4th thursday in November": {
							"name": {
								"en": "Day after Thanksgiving"
							}
						}
					}
				},
				"NJ": {
					"name": "New Jersey",
					"zones": [
						"America/New_York"
					],
					"days": {
						"02-12": {
							"name": {
								"en": "Lincoln's Birthday"
							}
						},
						"easter -2": {
							"_name": "easter -2"
						},
						"tuesday after 1st monday in November": {
							"name": {
								"en": "Election Day"
							}
						}
					}
				},
				"NM": {
					"name": "New Mexico",
					"zones": [
						"America/Denver"
					],
					"days": {
						"3rd monday in February": false,
						"friday after 4th thursday in November": {
							"name": {
								"en": "Day after Thanksgiving"
							}
						}
					}
				},
				"NY": {
					"name": "New York",
					"zones": [
						"America/New_York"
					],
					"days": {
						"02-12": {
							"name": {
								"en": "Lincoln's Birthday"
							}
						},
						"02-15": {
							"name": {
								"en": "Susan B. Anthony Day"
							}
						},
						"tuesday after 1st monday in November": {
							"name": {
								"en": "Election Day"
							}
						}
					}
				},
				"NC": {
					"name": "North Carolina",
					"zones": [
						"America/New_York"
					],
					"days": {
						"3rd monday in February": false,
						"2nd monday in October": false,
						"easter -2": {
							"_name": "easter -2"
						},
						"friday after 4th thursday in November": {
							"name": {
								"en": "Day after Thanksgiving"
							}
						},
						"12-24 and if friday then previous thursday if saturday,sunday then previous friday": {
							"substitute": true,
							"_name": "12-24"
						}
					}
				},
				"ND": {
					"name": "North Dakota",
					"zones": [
						"America/North_Dakota/Center",
						"America/North_Dakota/New_Salem",
						"America/North_Dakota/Beulah"
					]
				},
				"OH": {
					"name": "Ohio",
					"zones": [
						"America/New_York"
					]
				},
				"OK": {
					"name": "Oklahoma",
					"zones": [
						"America/Chicago"
					],
					"days": {
						"friday after 4th thursday in November": {
							"name": {
								"en": "Day after Thanksgiving"
							}
						}
					}
				},
				"OR": {
					"name": "Oregon",
					"zones": [
						"America/Los_Angeles"
					]
				},
				"PA": {
					"name": "Pennsylvania",
					"zones": [
						"America/New_York"
					],
					"days": {
						"06-14": {
							"name": {
								"en": "Flag Day"
							}
						}
					}
				},
				"RI": {
					"name": "Rhode Island",
					"zones": [
						"America/New_York"
					],
					"days": {
						"2nd monday in August": {
							"name": {
								"en": "Victory Day"
							}
						}
					}
				},
				"SC": {
					"name": "South Carolina",
					"zones": [
						"America/New_York"
					],
					"days": {
						"05-10": {
							"name": {
								"en": "Confederate Memorial Day"
							}
						},
						"12-26": {
							"_name": "12-26"
						}
					}
				},
				"SD": {
					"name": "South Dakota",
					"zones": [
						"America/Chicago",
						"America/Denver"
					]
				},
				"TN": {
					"name": "Tennessee",
					"zones": [
						"America/Chicago",
						"America/New_York"
					],
					"days": {
						"easter -2": {
							"_name": "easter -2"
						},
						"12-24": {
							"_name": "12-24"
						}
					}
				},
				"TX": {
					"name": "Texas",
					"zones": [
						"America/Chicago",
						"America/Denver"
					],
					"days": {
						"01-19": {
							"name": {
								"en": "Confederate Heroes Day"
							},
							"type": "observance",
							"note": "state agencies are partially staffed"
						},
						"03-02": {
							"name": {
								"en": "Texas Independence Day"
							},
							"type": "observance",
							"note": "state agencies are partially staffed"
						},
						"03-31": {
							"name": {
								"en": "Cesar Chavez Day"
							},
							"type": "observance"
						},
						"easter -2": {
							"_name": "easter -2",
							"type": "observance"
						},
						"04-21": {
							"name": {
								"en": "San Jacinto Day"
							},
							"type": "observance",
							"note": "state agencies are partially staffed"
						},
						"06-19": {
							"name": {
								"en": "Emancipation Day In Texas"
							},
							"type": "observance",
							"note": "state agencies are partially staffed"
						},
						"08-27": {
							"name": {
								"en": "Lyndon Baines Johnson Day"
							},
							"type": "observance",
							"note": "state agencies are partially staffed"
						},
						"friday after 4th thursday in November": {
							"name": {
								"en": "Day after Thanksgiving"
							}
						},
						"12-24": {
							"_name": "12-24"
						},
						"12-26": {
							"_name": "12-26",
							"name": {
								"en": "Day after Christmas"
							}
						}
					}
				},
				"UT": {
					"name": "Utah",
					"zones": [
						"America/Denver"
					],
					"days": {
						"07-24": {
							"name": {
								"en": "Pioneer Day"
							}
						}
					}
				},
				"VT": {
					"name": "Vermont",
					"zones": [
						"America/New_York"
					],
					"days": {
						"1st tuesday in March": {
							"name": {
								"en": "Town Meeting Day"
							}
						},
						"3rd monday in August": {
							"name": {
								"en": "Bennington Battle Day"
							}
						}
					}
				},
				"VA": {
					"name": "Virginia",
					"zones": [
						"America/New_York"
					],
					"days": {
						"friday before 3rd monday in January": {
							"name": {
								"en": "Lee–Jackson Day"
							}
						}
					}
				},
				"WA": {
					"name": "Washington",
					"zones": [
						"America/Los_Angeles"
					]
				},
				"WV": {
					"name": "West Virginia",
					"zones": [
						"America/New_York"
					],
					"days": {
						"02-15": {
							"name": {
								"en": "Susan B. Anthony Day"
							}
						},
						"06-20": {
							"name": {
								"en": "West Virginia Day"
							}
						},
						"4th friday in November": {
							"name": {
								"en": "Lincoln's Day"
							}
						}
					}
				},
				"WI": {
					"name": "Wisconsin",
					"zones": [
						"America/Chicago"
					],
					"days": {
						"02-15": {
							"name": {
								"en": "Susan B. Anthony Day"
							}
						},
						"2nd tuesday in September": {
							"name": {
								"en": "Primary Election Day"
							}
						},
						"tuesday after 1st monday in November": {
							"name": {
								"en": "Election Day"
							}
						}
					}
				},
				"WY": {
					"name": "Wyoming",
					"zones": [
						"America/Denver"
					]
				}
			}
		}
	},
	"names": {
		"01-01": {
			"name": {
				"en": "New Year's Day",
				"am": "እንቁጣጣሽ",
				"ar": "عيد رأس السنة",
				"az": "Yeni il",
				"be": "Новы год",
				"bg": "Нова Година",
				"bs": "Novogodisnji dan",
				"ca": "Any nou",
				"cz": "Nový rok",
				"da": "Nytår",
				"de": "Neujahr",
				"el": "Πρωτοχρονιά",
				"es": "Año Nuevo",
				"et": "uusaasta",
				"fi": "Uudenvuodenpäivä",
				"fo": "Nýggjársdagur",
				"fr": "Nouvel An",
				"hr": "Nova godina",
				"hu": "Újév",
				"hy": "Ամանոր",
				"it": "Capodanno",
				"is": "Nýársdagur",
				"jp": "元日",
				"ko": "신정",
				"lt": "Naujieji metai",
				"lv": "Jaunais Gads",
				"mg": "Taom-baovao",
				"mt": "L-Ewwel tas-Sena",
				"nl": "Nieuwjaar",
				"no": "Første nyttårsdag",
				"pl": "Nowy Rok",
				"pt": "Ano Novo",
				"ro": "Anul nou",
				"ru": "Новый год",
				"sq": "Viti i Ri",
				"sr": "Нова година",
				"sv": "Nyårsdagen",
				"sw": "Mwaka mpya",
				"tr": "Yılbaşı",
				"vi": "Tết dương lịch",
				"zh": "元旦"
			}
		},
		"01-06": {
			"name": {
				"en": "Epiphany",
				"am": "ብርሐነ ጥምቀት",
				"de": "Heilige Drei Könige",
				"es": "Día de los Reyes Magos",
				"et": "kolmekuningapäev",
				"fi": "Loppiainen",
				"fr": "l'Épiphanie",
				"el": "Θεοφάνεια",
				"hr": "Bogojavljenje, Sveta tri kralja",
				"it": "Befana",
				"is": "Þrettándinn",
				"nl": "Driekoningen",
				"pl": "Święto Trzech Króli",
				"sv": "Trettondedag jul"
			}
		},
		"02-02": {
			"name": {
				"en": "Candlemas",
				"de": "Lichtmess"
			}
		},
		"02-14": {
			"name": {
				"en": "Valentine's Day",
				"de": "Valentinstag",
				"fr": "Saint-Valentin",
				"nl": "Valentijnsdag"
			}
		},
		"03-08": {
			"name": {
				"en": "International Women's Day",
				"az": "Qadınlar günü",
				"be": "Мiжнародны жаночы дзень",
				"bg": "Ден на жената",
				"hu": "Nemzetközi nőnap",
				"hy": "Կանանց տոն",
				"ru": "Международный женский день",
				"vi": "Quốc tế Phụ nữ",
				"zh": "国际妇女节"
			}
		},
		"03-19": {
			"name": {
				"en": "Saint Joseph",
				"de-at": "Josefitag",
				"de": "Josefstag",
				"es": "San José",
				"mt": "San Ġużepp"
			}
		},
		"04-01": {
			"name": {
				"en": "April Fools' Day",
				"sq": "Dita e Gënjeshtrave"
			}
		},
		"05-01": {
			"name": {
				"en": "Labour Day",
				"en-us": "Labor Day",
				"ar": "يوم العمال",
				"be": "Дзень працы",
				"bg": "Ден на труда",
				"bs": "Radni dan",
				"cz": "Svátek práce",
				"de": "Tag der Arbeit",
				"el": "Εργατική Πρωτομαγιά",
				"es": "Fiesta del trabajo",
				"et": "kevadpüha",
				"fi": "Vappu",
				"fr": "Fête du travail",
				"hr": "Praznik rada",
				"hu": "A munka ünnepe",
				"hy": "Աշխատանքի օր",
				"it": "Festa del Lavoro",
				"is": "Hátíðisdagur Verkamanna",
				"lt": "Tarptautinė darbo diena",
				"lv": "Darba svētki",
				"nl": "Dag van de Arbeid",
				"no": "Første mai",
				"mg": "Fetin'ny asa",
				"mt": "Jum il-Ħaddiem",
				"pl": "Święto Pracy",
				"pt": "Dia do trabalhador",
				"ro": "Ziua muncii",
				"sq": "Dita Ndërkombëtare e Punonjësve",
				"sr": "Празник рада",
				"sv": "Första Maj",
				"vi": "Ngày Quốc tế Lao động",
				"zh": "劳动节"
			}
		},
		"06-29": {
			"name": {
				"en": "Saint Peter and Saint Paul",
				"es": "San Pedro y San Pablo",
				"mt": "L-Imnarja"
			}
		},
		"08-15": {
			"name": {
				"en": "Assumption",
				"de": "Mariä Himmelfahrt",
				"es": "Asunción",
				"fr": "Assomption",
				"el": "Κοίμηση της Θεοτόκου",
				"hr": "Velika Gospa",
				"it": "Ferragosto",
				"lt": "Žolinė",
				"mg": "Asompsiona",
				"mt": "Santa Marija",
				"nl": "O.L.V. Hemelvaart",
				"pl": "Wniebowzięcie Najświętszej Maryi Panny",
				"pt": "Assunção",
				"ro": "Adormirea Maicii Domnului",
				"sq": "Shën Mëria e Gushtit"
			}
		},
		"11-01": {
			"name": {
				"en": "All Saints' Day",
				"bs": "Dita e të gjithë Shenjtorëve",
				"de": "Allerheiligen",
				"es": "Todos los Santos",
				"fi": "Pyhäinpäivä",
				"fr": "Toussaint",
				"hr": "Svi sveti",
				"hu": "Mindenszentek",
				"it": "Ognissanti",
				"lt": "Visų šventųjų diena",
				"mg": "Fetin'ny olo-masina",
				"nl": "Allerheiligen",
				"pl": "Wszystkich Świętych",
				"pt": "Todos os santos",
				"sq": "Të gjitha Saints",
				"sr": "Сви Свети",
				"sv": "Alla helgons dag"
			}
		},
		"11-02": {
			"name": {
				"en": "All Souls' Day",
				"de": "Allerseelen",
				"es": "Día de los Difuntos",
				"et": "hingedepäev",
				"fr": "Fête des morts",
				"hr": "Dušni dan",
				"nl": "Allerzielen",
				"pt": "Dia de Finados"
			}
		},
		"11-11": {
			"name": {
				"en": "Saint Martin",
				"de": "Sankt Martin (Faschingsbeginn)",
				"nl": "Sint Maarten"
			}
		},
		"12-06": {
			"name": {
				"en": "Saint Nicholas",
				"de": "Sankt Nikolaus",
				"fr": "Saint-Nicolas",
				"nl": "Sinterklaas"
			}
		},
		"12-08": {
			"name": {
				"en": "Immaculate Conception",
				"de": "Mariä Empfängnis",
				"es": "La inmaculada concepción",
				"fr": "Immaculée Conception",
				"it": "Immacolata Concezione",
				"mt": "Il-Kunċizzjoni",
				"pt": "Imaculada Conceição"
			}
		},
		"12-24": {
			"name": {
				"en": "Christmas Eve",
				"bg": "Бъдни вечер",
				"bs": "Badnji dan",
				"cz": "Štědrý den",
				"de": "Heiliger Abend",
				"es": "Nochebuena",
				"et": "jõululaupäev",
				"fo": "Jólaaftan",
				"fi": "Jouluaatto",
				"hr": "Badnji dan",
				"is": "Aðfangadagur",
				"lt": "Šv. Kūčios",
				"lv": "Ziemassvētku vakars",
				"nl": "Kerstavond",
				"no": "Julaften",
				"pt": "Noite de Natal",
				"sq": "Nata e Krishtlindjes",
				"sr": "Бадњи дан",
				"sv": "Julafton"
			}
		},
		"12-25": {
			"name": {
				"en": "Christmas Day",
				"am": "ልደተ-ለእግዚእነ/ ገና",
				"bg": "Коледа",
				"bs": "Božić",
				"de-at": "Christtag",
				"ca": "Nadal",
				"cz": "1. svátek vánoční",
				"da": "1. Juledag",
				"de": "Weihnachten",
				"el": "Χριστούγεννα",
				"es": "Navidad",
				"et": "esimene jõulupüha",
				"fi": "Joulupäivä",
				"fo": "Fyrsti jóladagur",
				"fr": "Noël",
				"hr": "Božić",
				"hu": "Karácsony",
				"hy": "Սուրբ Ծնունդ",
				"it": "Natale",
				"is": "Jóladagur",
				"jp": "ノエル",
				"ko": "기독탄신일",
				"lt": "Šv. Kalėdos",
				"lv": "Ziemassvētki",
				"mg": "Krismasy",
				"mt": "Il-Milied",
				"nl": "Kerstmis",
				"no": "Første Juledag",
				"pl": "Pierwszy dzień Bożego Narodzenia",
				"pt": "Natal",
				"ro": "Crăciunul",
				"ru": "Рождество Христово",
				"sq": "Krishtlindja",
				"sr": "Божић",
				"sv": "Juldagen",
				"sw": "Krismasi"
			}
		},
		"12-26": {
			"name": {
				"en": "Boxing Day",
				"de-at": "Stefanitag",
				"bg": "2-ри ден на Коледа",
				"cz": "2. svátek vánoční",
				"da": "2. Juledag",
				"de": "2. Weihnachtstag",
				"el": "Δεύτερη μέρα των Χριστουγέννων",
				"es": "San Esteban",
				"et": "teine jõulupüha",
				"fi": "2. joulupäivä",
				"fo": "Fyrsti gerandisdagur eftir jóladag",
				"fr": "Lendemain de Noël",
				"hr": "Svetog Stjepana",
				"hu": "Karácsony másnapja",
				"it": "Santo Stefano",
				"is": "Annar í jólum",
				"lt": "2. Kalėdų diena",
				"lv": "Otrie Ziemassvētki",
				"nl": "Tweede kerstdag",
				"no": "Andre juledag",
				"pl": "Drugi dzień Bożego Narodzenia",
				"ro": "Două zi de Crăciun",
				"sv": "Annandag jul"
			}
		},
		"12-31": {
			"name": {
				"en": "New Year's Eve",
				"da": "Nytårsaften",
				"de": "Silvester",
				"es": "Fin del Año",
				"fi": "Uudenvuodenaatto",
				"fo": "Nýggjársaftan",
				"fr": "Saint-Sylvestre",
				"hu": "Szilveszter",
				"hy": "Նոր տարվա գիշեր",
				"is": "Gamlársdagur",
				"jp": "大晦日",
				"lv": "Vecgada vakars",
				"nl": "Oudjaar",
				"no": "Nyttårsaften",
				"pt": "Véspera de Ano Novo",
				"sv": "Nyårsafton"
			}
		},
		"easter -48": {
			"name": {
				"en": "Shrove Monday",
				"es": "Carnaval",
				"fr": "Lundi de Carnaval",
				"de": "Rosenmontag"
			}
		},
		"easter -47": {
			"name": {
				"en": "Shrove Tuesday",
				"es": "Carnaval",
				"de": "Faschingsdienstag",
				"hr": "Pokladni utorak",
				"pt": "Carnaval"
			}
		},
		"easter -46": {
			"name": {
				"en": "Ash Wednesday",
				"de": "Aschermittwoch",
				"es": "Miercoles de Ceniza",
				"fr": "Mercredi des Cendres",
				"it": "Ceneri",
				"is": "Öskudagur",
				"sw": "Jumatano ya Majivu"
			}
		},
		"easter -7": {
			"name": {
				"en": "Palm Sunday",
				"de": "Palmsonntag",
				"es": "Domingo de Ramos",
				"it": "Domenica delle Palme",
				"is": "Pálmasunnudagur",
				"no": "Palmesøndag"
			}
		},
		"easter -3": {
			"name": {
				"en": "Maundy Thursday",
				"cz": "Zelený čtvrtek",
				"da": "Skærtorsdag",
				"de": "Gründonnerstag",
				"es": "Jueves Santo",
				"fo": "Skírhósdagur",
				"fr": "Jeudi saint",
				"it": "Giovedì santo",
				"is": "Skírdagur",
				"nl": "Witte donderdag",
				"no": "Skjærtorsdag"
			}
		},
		"easter -2": {
			"name": {
				"en": "Good Friday",
				"am": "ስቅለት",
				"bg": "Разпети петък",
				"bs": "Dobar petak",
				"cz": "Velikonoční pátek",
				"da": "Langfredag",
				"de": "Karfreitag",
				"es": "Viernes Santo",
				"fi": "Pitkäperjantai",
				"fo": "Langafríggjadagur",
				"fr": "Vendredi saint",
				"el": "Μεγάλη Παρασκευή",
				"et": "suur reede",
				"hr": "Veliki petak",
				"it": "Venerdì santo",
				"is": "Föstudagurinn langi",
				"lv": "Lielā Piektdiena",
				"mt": "Il-Ġimgħa l-Kbira",
				"nl": "Goede Vrijdag",
				"no": "Langfredag",
				"pt": "Sexta-Feira Santa",
				"sq": "E Premtja e Madhe",
				"sr": "Велики петак",
				"sv": "Långfredagen",
				"sw": "Ijumaa Kuu"
			}
		},
		"easter -1": {
			"name": {
				"en": "Easter Saturday",
				"cz": "Bílá sobota",
				"de": "Karsamstag",
				"es": "Sabado Santo",
				"fr": "Samedi saint",
				"it": "Sabado santo"
			}
		},
		"easter": {
			"name": {
				"en": "Easter Sunday",
				"am": "ፋሲካ",
				"bg": "Великден",
				"bs": "Vaskrs",
				"cz": "Neděle velikonoční",
				"da": "Påskesøndag",
				"de": "Ostersonntag",
				"el": "Πάσχα",
				"es": "Pascua",
				"et": "lihavõtted",
				"fi": "Pääsiäispäivä",
				"fo": "Páskadagur",
				"fr": "Pâques",
				"hr": "Uskrs",
				"hu": "Húsvétvasárnap",
				"it": "Domenica di Pasqua",
				"is": "Páskadagur",
				"lt": "Velykos",
				"lv": "Lieldienas",
				"nl": "Pasen",
				"no": "Første påskedag",
				"pl": "Niedziela Wielkanocna",
				"pt": "Páscoa",
				"ro": "Paștele",
				"sq": "Pashkët",
				"sr": "Васкрс",
				"sv": "Påsk",
				"sw": "Pasaka"
			}
		},
		"easter 1": {
			"name": {
				"en": "Easter Monday",
				"bg": "Велики понеделник",
				"cz": "Velikonoční pondělí",
				"da": "Anden påskedag",
				"de": "Ostermontag",
				"el": "Δευτέρα του Πάσχα",
				"es": "Lunes de Pascua",
				"fi": "2. pääsiäispäivä",
				"fo": "Annar páskadagur",
				"fr": "Lundi de Pâques",
				"hr": "Drugi dan Uskrsa",
				"hu": "Húsvéthétfő",
				"it": "Lunedì dell’Angelo",
				"is": "Annar í páskum",
				"lv": "Otrās Lieldienas",
				"mg": "Alatsinain'ny Paska",
				"nl": "Paasmaandag",
				"no": "Andre påskedag",
				"pl": "Drugi dzień Wielkanocy",
				"ro": "Două zi de Pasti",
				"sv": "Annandag påsk",
				"sw": "Jumatatu ya Pasaka"
			}
		},
		"easter 39": {
			"name": {
				"en": "Ascension Day",
				"da": "Kristi Himmelfartsdag",
				"de": "Christi Himmelfahrt",
				"es": "La Asunción",
				"fi": "Helatorstai",
				"fo": "Kristi Himmalsferðardagur",
				"fr": "Ascension",
				"it": "Ascensione",
				"is": "Uppstigningardagur",
				"mg": "Andro niakarana",
				"nl": "O.L.H. Hemelvaart",
				"no": "Kristi himmelfartsdag",
				"ro": "Ziua Eroilor",
				"sv": "Kristi himmelfärds dag"
			}
		},
		"easter 49": {
			"name": {
				"en": "Pentecost",
				"da": "Pinsedag",
				"de": "Pfingstsonntag",
				"el": "Αγίου Πνεύματος",
				"es": "Pentecostés",
				"et": "nelipühade 1. püha",
				"fi": "Helluntaipäivä",
				"fo": "Hvítusunnudagur",
				"fr": "Pentecôte",
				"hu": "Pünkösdvasárnap",
				"it": "Pentecoste",
				"is": "Hvítasunnudagur",
				"nl": "Pinksteren",
				"no": "Første pinsedag",
				"pl": "Zielone Świątki",
				"ro": "Rusaliile",
				"sv": "Pingst"
			}
		},
		"easter 50": {
			"name": {
				"en": "Whit Monday",
				"da": "2. Pinsedag",
				"de": "Pfingstmontag",
				"es": "Lunes de Pentecostés",
				"fo": "Annar hvítusunnudagur",
				"fr": "Lundi de Pentecôte",
				"hu": "Pünkösdhétfő",
				"it": "Lunedì di Pentecoste",
				"is": "Annar í hvítasunnu",
				"mg": "Alatsinain'ny Pentekosta",
				"nl": "Pinkstermaandag",
				"no": "Andre pinsedag",
				"ro": "Două zi de Rusalii"
			}
		},
		"easter 60": {
			"name": {
				"en": "Corpus Christi",
				"de": "Fronleichnam",
				"es": "Corpus Christi",
				"fr": "la Fête-Dieu",
				"it": "Corpus Domini",
				"hr": "Tijelovo",
				"pl": "Dzień Bożego Ciała",
				"pt": "Corpo de Deus"
			}
		},
		"1 Muharram": {
			"name": {
				"en": "Islamic New Year",
				"ar": "رأس السنة الهجرية",
				"bs": "Nova hidžretska godina",
				"hr": "Nova hidžretska godina",
				"sq": "Viti i Ri hixhri"
			}
		},
		"10 Muharram": {
			"name": {
				"en": "Day of Ashura",
				"ar": "عاشوراء"
			}
		},
		"1 Shawwal": {
			"name": {
				"en": "End of Ramadan (Eid al-Fitr)",
				"am": "ዒድ አል ፈጥር",
				"ar": "عيد الفطر",
				"az": "Ramazan Bayramı",
				"bs": "Ramazanski bajram",
				"de": "Zuckerfest",
				"fr": "Fête de fin du Ramadan",
				"nl": "Suikerfeest (Eid al-Fitr)",
				"sq": "Fitër Bajrami",
				"tr": "Bayramı",
				"sw": "Idd-ul-Fitr"
			}
		},
		"10 Dhu al-Hijjah": {
			"name": {
				"en": "Feast of the Sacrifice (Eid al-Adha)",
				"am": "ዒድ አል አድሐ",
				"ar": "عيد الأضحى",
				"az": "Qurban Bayramı",
				"bs": "Kurbanski bajram",
				"de": "Opferfest",
				"fr": "Fête du mouton",
				"nl": "Offerfeest (Eid Al-Adha)",
				"sq": "Kurban Bajrami",
				"tr": "Kurban Bayramı",
				"sw": "Idd-ul-Azha"
			}
		},
		"12 Rabi al-awwal": {
			"name": {
				"en": "Birthday of Muhammad (Mawlid)",
				"am": "መውሊድ",
				"ar": "المولد النبويّ",
				"bs": "Mevlud",
				"fr": "Mawlid",
				"sq": "Mevludi"
			}
		},
		"27 Rajab": {
			"name": {
				"en": "Laylat al-Mi'raj",
				"ar": "الإسراء والمعراج",
				"bs": "Lejletul Mi'radž",
				"sq": "Nata e Miraxhit",
				"tr": "Miraç Gecesi"
			}
		},
		"15 Shaban": {
			"name": {
				"en": "Laylat al-Bara'at",
				"ar": "ليلة البراءة",
				"bs": "Lejletul berat",
				"sq": "Nata e Beratit"
			}
		},
		"1 Ramadan": {
			"name": {
				"en": "First day of Ramadan",
				"am": "ረመዳን",
				"ar": "اليوم الأول من رمضان",
				"bs": "Prvi dan posta",
				"sq": "Dita e parë e agjërimit"
			}
		},
		"27 Ramadan": {
			"name": {
				"en": "Laylat al-Qadr",
				"ar": "لیلة القدر",
				"bs": "Lejletul kadr",
				"sq": "Nata e Kadrit"
			}
		},
		"15 Nisan": {
			"name": {
				"en": "Pesach",
				"bs": "Pesah",
				"de": "Pessach",
				"hr": "Pesač",
				"sq": "Pesach",
				"sr": "Песах"
			}
		},
		"1 Tishrei": {
			"name": {
				"en": "Rosh Hashanah",
				"bs": "Roš Hašana",
				"de": "Rosch Haschana",
				"hr": "Roš Hašane",
				"sq": "Rosh Hashanah",
				"sr": "Рош Хашана"
			}
		},
		"10 Tishrei": {
			"name": {
				"en": "Yom Kippur",
				"bs": "Jom Kipur",
				"de": "Jom Kippur",
				"hr": "Jom Kipur",
				"sq": "Yom Kippur",
				"sr": "Јом Кипур"
			}
		},
		"Abolition of Slavery": {
			"name": {
				"en": "Abolition of Slavery",
				"fr": "Abolition de l’esclavage",
				"nl": "Afschaffing van de slavernij"
			}
		},
		"Buß- und Bettag": {
			"name": {
				"de": "Buß- und Bettag",
				"en": "Day of Prayer and Repentance"
			}
		},
		"Constitution Day": {
			"name": {
				"en": "Constitution Day",
				"da": "Grundlovsdag",
				"de": "Tag der Verfassung",
				"ca": "Dia de la Constitució",
				"es": "Día de la Constitución",
				"fo": "Grundlógardagur",
				"hy": "Սահմանադրության օր",
				"jp": "憲法記念日",
				"ko": "제헌절",
				"no": "Grunnlovsdagen",
				"pt": "Dia da Constituição"
			}
		},
		"Fathers Day": {
			"name": {
				"en": "Father's Day",
				"et": "isadepäev",
				"lt": "Tėvo diena",
				"nl": "Vaderdag",
				"pt": "Dia dos Pais"
			}
		},
		"Independence Day": {
			"name": {
				"en": "Independence Day",
				"ar": "عيد الاستقلال",
				"be": "Дзень Незалежнасцi",
				"bg": "Ден на независимостта",
				"bs": "Dan nezavisnosti",
				"de": "Unabhängigkeitstag",
				"es": "Día de la Independencia",
				"et": "iseseisvuspäev",
				"fi": "Itsenäisyyspäivä",
				"fr": "Jour de l'Indépendance",
				"hr": "Dan neovisnosti",
				"hy": "Անկախության օր",
				"mt": "Jum l-Indipendenza",
				"nl": "Onafhankelijkheidsdag",
				"pl": "Narodowe Święto Niepodległości",
				"pt": "Dia da Independência",
				"sq": "Dita e Pavarësisë",
				"sr": "Дан независности",
				"sv": "Självständighetsdagen",
				"sw": "Siku ya uhuru"
			}
		},
		"Liberation Day": {
			"name": {
				"en": "Liberation Day",
				"sq": "Dita e Çlirimit"
			}
		},
		"Mothers Day": {
			"name": {
				"en": "Mother's Day",
				"cz": "Den matek",
				"da": "Mors Dag",
				"de": "Muttertag",
				"el": "Γιορτή της μητέρας",
				"es": "Día de la Madre",
				"et": "emadepäev",
				"fi": "Äitien päivä",
				"fr": "Fête des Mères",
				"hr": "Majčin dan",
				"hu": "Anyák napja",
				"hy": "Ցեղասպանության զոհերի հիշատակի օր",
				"is": "Mæðradagurinn",
				"it": "Festa della mamma",
				"lt": "Motinos diena",
				"lv": "Mātes diena",
				"nl": "Moederdag",
				"no": "Morsdag",
				"pt": "Dia das Mães",
				"pl": "Dzień Matki",
				"ro": "Ziua Mamei",
				"sq": "Dita e Nënës",
				"sv": "Mors dag"
			}
		},
		"National Holiday": {
			"name": {
				"en": "National Holiday",
				"de": "Nationalfeiertag",
				"es": "Fiesta Nacional",
				"fr": "Fête nationale",
				"el": "εθνική επέτειος",
				"nl": "Nationale feestdag"
			}
		},
		"Public Holiday": {
			"name": {
				"en": "Public Holiday",
				"fr": "Jour férié légaux",
				"pt": "Feriado Obrigatório"
			}
		},
		"Reformation Day": {
			"name": {
				"en": "Reformation Day",
				"de": "Reformationstag",
				"es": "Día Nacional de las Iglesias Evangélicas y Protestantes"
			}
		},
		"Revolution Day": {
			"name": {
				"en": "Revolution Day",
				"es": "Día de la Revolución",
				"nl": "Dag van de revolutie"
			}
		},
		"substitutes": {
			"name": {
				"en": "substitute day",
				"az": "əvəz gün",
				"bs": "zamjena dan",
				"de": "Ersatztag",
				"es": "día sustituto",
				"fr": "jour substitut",
				"nl": "substituut",
				"hr": "zamjena dan",
				"jp": "代替日",
				"lv": "aizstājējs diena",
				"sq": "ditë zëvendësuese",
				"sr": "замена дан"
			}
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/date-holidays/data/holidays.json
// module id = ./node_modules/date-holidays/data/holidays.json
// module chunks = 0